import {Action} from '@ngrx/store';
import { type} from '../../shared';

export const removeOrderPlayerActionTypes = {
  REMOVE: type('[Player Order] Remove'),
  REMOVE_SUCCESS: type('[Player Order] Remove Success'),
  REMOVE_FAIL: type('[Player Order] Remove Fail')
};

export class RemoveOrderPlayerAction implements Action {
  readonly type = removeOrderPlayerActionTypes.REMOVE;
  constructor(public payload?: string ) {}
}

export class RemoveOrderPlayerSuccessAction implements Action {
  readonly type = removeOrderPlayerActionTypes.REMOVE_SUCCESS;
  constructor() {}
}

export class RemoveOrderPlayerFailAction implements Action {
  readonly type = removeOrderPlayerActionTypes.REMOVE_FAIL;
  constructor(public payload?: string) {}
}

